import React, { ChangeEvent, useContext } from 'react';
import { createUseStyles } from 'react-jss';
import FormStructureContext from '../../context/FormStructureContext';
import InputContext from '../../context/InputContext';
import { SET_FIELD } from '../../hooks/reducer';
import useAlgorithm from '../../hooks/useAlgorithm';
import { IForm } from '../../schema/interface';
import { defaultMetadata } from '../../schema/preDefinedConst';

const styles = createUseStyles({
    input: {
        padding: '.375rem .75rem',
        borderColor: '#bbbbbb',
        borderStyle: 'solid',
        borderWidth: '1px',
        borderRadius: '4px',
        backgroundColor: 'white',
        color: '#363636',
        lineHeight: '1.5',
        height: 'calc(1.5em + .75rem + 2px)',
        // minWidth: '125px',
        width: '100%',
        fontSize: '1em',
        fontFamily: 'inherit',
        '&:focus': {
            outline: 'none',
            borderColor: '#1b90fa',
            boxShadow: '0 0 0 0.2rem rgb(0 123 255 / 25%)'
        }
    }
});
const NumberInput = ({
    metadata = defaultMetadata,
    presentation,
    name,
    value,
    handleChangeVisible,
    formValues,
    noAccess
}: IForm) => {
    const classes = styles();
    const { min, max } = metadata;
    const { dispatch } = useContext(InputContext);
    const { fetchedFormStructure: formStructure } = useContext(FormStructureContext);
    const handleChange = (e: ChangeEvent<HTMLInputElement>) => {
        const newValue = e.target.value;
        dispatch({
            type: SET_FIELD,
            name,
            value: newValue
        });
    };

    const { handleAlgorithmCode } = useAlgorithm({
        formStructure,
        formValues,
        handleChangeVisible
    });
    return (
        <input
            type="number"
            className={classes.input}
            name={name}
            value={value}
            max={max}
            min={min}
            maxLength={max ? max.toString().length : null}
            minLength={min ? min.toString().length : null}
            disabled={noAccess}
            onBlur={handleAlgorithmCode}
            onChange={handleChange}
            required={presentation?.required}
            onWheel={(event) => event.currentTarget.blur()}
            step="any"
        />
    );
};
export default NumberInput;
